var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { svgIcon } from '../svg-icon';
/**
 * @tdr
 */
export var OpenLink = svgIcon(function (props) { return (React.createElement("svg", __assign({}, props, { viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg" }),
    React.createElement("path", { fill: "currentColor", d: "M17.2 20H0V2.9h12.1v1.42H1.4v14.25H15.8v-9.5h1.4V20Z" }),
    React.createElement("path", { fill: "currentColor", d: "m18.64.38-7.28 7.94 1.02.98 7.28-7.94-1.02-.98Z" }),
    React.createElement("path", { fill: "currentColor", d: "M20 7.65h-1.4V1.43l-5.58.04V.05L20 0v7.65Z" }))); });
//# sourceMappingURL=OpenLink.js.map